import React from 'react';
import PropTypes from 'prop-types';
import { zendesk } from 'bv-services';

const LiveChat = ({ label }) => (
  <div className="left-component__link-item-wrapper">
    <span className="left-components__link left-component__link-item" onClick={zendesk.liveChat}>
      {label}
    </span>
  </div>
);

LiveChat.propTypes = {
  label: PropTypes.string.isRequired,
};

export default LiveChat;
